import React, { useCallback } from 'react';
import appConfig from 'app-config';
import { pageTemplateProps } from '@xengage/gw-portals-wizard-react';
import WizardPageHeader from '../../components/WizardPageHeader/WizardPageHeader'
import WizardSingleErrorComponent from '../../../WizardSingleErrorComponent/WizardSingleErrorComponent'
import DigitalWizardPageTemplate from '../DigitalWizardPageTemplate';
import DigitalAMPWizardPageTemplate from '../DigitalAMPWizardPageTemplate';

import styles from './DigitalWizardPageWithTitleTemplate.module.scss';

function DigitalWizardPageWithTitleTemplate(props) {
    const {
        children, acknowledgeError, errorsForStep, isSideHeader, policyChangePageHeaderML, ...otherProps
    } = props;

    const renderWizardHeader = useCallback(
        (wizardData) => {
            const getSubmissionVM = wizardData.submissionVM || wizardData;
            return (
                <WizardPageHeader wizardSubmission={getSubmissionVM} isSideHeader={isSideHeader} policyChangePageHeaderML={policyChangePageHeaderML} />
            );
        },
        [isSideHeader, policyChangePageHeaderML]
    );

    const isAMP = appConfig.portalCode === 'AMP';
    if (isAMP) {
        return (
            <div className={styles.wizardContainer}>
                <DigitalAMPWizardPageTemplate
                    renderContextComponent={renderWizardHeader}
                    showContextComponent={false}
                    showWizardHeader
                    {...otherProps}
                >
                    <WizardSingleErrorComponent
                        acknowledgeError={acknowledgeError}
                        issuesList={errorsForStep}
                    />
                    {children}
                </DigitalAMPWizardPageTemplate>
            </div>
        )
    }
    return (
        <div className={styles.wizardContainer}>
            <DigitalWizardPageTemplate
                renderContextComponent={renderWizardHeader}
                showContextComponent={false}
                showWizardHeader
                {...otherProps}
            >
                <WizardSingleErrorComponent
                    acknowledgeError={acknowledgeError}
                    issuesList={errorsForStep}
                />
                {children}
            </DigitalWizardPageTemplate>
        </div>
    );
}

DigitalWizardPageWithTitleTemplate.propTypes = pageTemplateProps;
export default DigitalWizardPageWithTitleTemplate;
